import ExpandTooltip from 'components/forecast-table/expand-tooltip/expand-tooltip';

function onceClickHandler(cb) {
  function click() {
    cb();
    document.body.removeEventListener('click', click);
  }

  document.body.addEventListener('click', click);
}

function ExpandTooltipPlugin($pool) {
  const tooltip = new ExpandTooltip().create('');
  let wasCalled = false;

  return function run(eventName, payload) {
    const { tableName, node } = payload;
    if (eventName !== 'Table:connectContent') return;
    if (tableName !== 'basic') return;
    if (wasCalled) return;

    const cell = node.querySelector('.js-fctable-day');
    if (!cell) return;

    wasCalled = true;
    $pool.push('Table:connectContent::idle', () => {
      const { mode } = cell.dataset;
      const text = cell.dataset[`tooltip${mode.toUpperCase()}`];
      if (text) tooltip.updateText(text).hide();
    });

    $pool.push('Table:connectContent::finish', () => {
      const icons = cell.querySelectorAll('i');
      const el = icons.length ? icons[icons.length - 1] : cell;

      tooltip.append(document.body, () => {
        tooltip.moveTo(el, () => {
          tooltip.show();
          tooltip.listenResize(el);
          tooltip.listenScroll(el);
          tooltip.listenMutations(el);
          tooltip.listenLayoutUpdates(el);

          wasCalled = false;

          onceClickHandler(() => {
            if (tooltip.isInDOM)
              tooltip.remove(() => tooltip.removeListeners());
          });
        });
      });
    });
  };
}

export default ExpandTooltipPlugin;
